import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { database } from '../../Firebase';
import { ref, onValue } from 'firebase/database';

const PanipuravthaNamuna1Print = () => {
    const location = useLocation();
    const { fromDate, toDate } = location.state || {};
    const [incomeData, setIncomeData] = useState([]);
    const [expenseData, setExpenseData] = useState([]);
    // Mocking structure for now, would populate with real aggregated data in a real scenario
    // For demonstration, we'll try to fetch some real transaction data if available or use structure matching the image
    
    useEffect(() => {
        // Fetch Income (RokhJama)
        // This is a simplified fetch to show data availability. 
        // In a full implementation, we'd aggregate by Head (Shirshak).
        const fetchData = () => {
             // Mock Data matching the image image for visual fidelity first
             const mockIncome = [
                 { head: 'कर व फी', subHeads: [
                     { name: 'सामान्य पाणीपट्टी', currentEst: 0, currentSanctioned: 100, lastYear: 0, prevYear: 0 },
                     { name: 'खास पाणीपट्टी', currentEst: 0, currentSanctioned: 500, lastYear: 0, prevYear: 0 },
                 ]},
                 { head: 'किरकोळ जमा रकमा', subHeads: [
                     { name: 'किरकोळ जमा रकमा', currentEst: 287, currentSanctioned: 0, lastYear: 0, prevYear: 0 },
                 ]},
                 { head: 'कर्ज अनामत व आगाऊ रकमा', subHeads: [
                     { name: 'अनामत रकमा', currentEst: 1560, currentSanctioned: 200000, lastYear: 0, prevYear: 0 },
                 ]},
                 { head: 'पाणी पुरवठा (अंशदान)', subHeads: [
                     { name: 'पाणीपट्टी नोटीस फी', currentEst: 0, currentSanctioned: 200, lastYear: 0, prevYear: 0 },
                     { name: 'पाणीपट्टी जप्ती फी', currentEst: 0, currentSanctioned: 500, lastYear: 0, prevYear: 0 },
                 ]},
                 { head: 'कपात', subHeads: [
                     { name: 'भविष्य निधीचे अंशदान', currentEst: 0, currentSanctioned: 50000, lastYear: 0, prevYear: 0 },
                 ]}
             ];

             const mockExpense = [
                { head: 'कर्ज', subHeads: [
                    { name: 'आगाऊ दिलेल्या रकमा', currentEst: 0, currentSanctioned: 20000, lastYear: 0, prevYear: 0 },
                ]},
                { head: 'कर्ज अनामत व आगाऊ रकमा', subHeads: [
                    { name: 'अनामत रकमा', currentEst: 1000, currentSanctioned: 2000000, lastYear: 0, prevYear: 0 },
                ]},
                { head: 'सामान्य कारभार', subHeads: [
                    { name: 'कार्यालयाचा नैमित्तिक खर्च', currentEst: 0, currentSanctioned: 50000, lastYear: 0, prevYear: 0 },
                ]},
                { head: 'पाणीपुरवठा', subHeads: [
                    { name: 'नबिन पाणीपुरवठा', currentEst: 0, currentSanctioned: 1000, lastYear: 0, prevYear: 0 },
                ]}
            ];

             setIncomeData(mockIncome);
             setExpenseData(mockExpense);
             
             setTimeout(() => {
                 window.print();
             }, 1000);
        };
        
        fetchData();
    }, []);

    // Helper to calculate totals
    const calculateTotal = (data, field) => {
        let total = 0;
        data.forEach(group => {
            group.subHeads.forEach(item => {
                total += item[field] || 0;
            });
        });
        return total;
    };

    // Helper to flatten data for display
    const flattenData = (data) => {
        let rows = [];
        data.forEach(group => {
            // Header Row
            rows.push({ type: 'header', content: group.head });
            // Items
            group.subHeads.forEach(item => {
                rows.push({ type: 'item', ...item });
            });
            // Total Row
            rows.push({ 
                type: 'total', 
                currentEst: group.subHeads.reduce((s, i) => s + i.currentEst, 0),
                currentSanctioned: group.subHeads.reduce((s, i) => s + i.currentSanctioned, 0),
                lastYear: group.subHeads.reduce((s, i) => s + i.lastYear, 0),
                prevYear: group.subHeads.reduce((s, i) => s + i.prevYear, 0)
            });
        });
        return rows;
    };

    const flatIncome = flattenData(incomeData);
    const flatExpense = flattenData(expenseData);
    const maxRows = Math.max(flatIncome.length, flatExpense.length);

    return (
        <div className="bg-gray-100 min-h-screen p-8 flex justify-center">
            <div className="bg-white p-8 w-full max-w-[297mm] shadow-lg print:shadow-none print:w-full print:max-w-none print:p-0 font-serif text-black print-container">
                {/* Title Section */}
                <div className="text-center mb-6">
                    <h1 className="text-2xl font-bold mb-2 text-[#267c77] print:text-black">नमुना नं. १</h1>
                    <p className="font-semibold text-lg mb-1">
                        सन 2025-2026 या सालासाठी ग्रामपंचायत इनाम धामणी मिरज तालुक्याच्या सांगली जिल्ह्याच्या अंदाजपत्रकातील विवरनपत्रक
                    </p>
                    <p className="font-bold">दिनांक 31/03/2026</p>
                </div>

                {/* Main Table */}
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-black text-center text-[10px] md:text-xs">
                        <thead>
                            {/* Header Row 1 */}
                            <tr className="bg-gray-50">
                                <th className="border border-black p-1 w-16">सुरुवातीची शिल्लक</th>
                                <th className="border border-black p-1">जमेचे शिर्षक</th>
                                <th className="border border-black p-1 w-16">सन <br/>2025-2026 या<br/>वर्षासाठी<br/>पंचायतीने<br/>अंदाजलेली<br/>प्रगती</th>
                                <th className="border border-black p-1 w-16">सन <br/>2025-2026<br/>चालु वर्षासाठी<br/>मंजुर केलेली<br/>अंदाजी रक्कम</th>
                                <th className="border border-black p-1 w-16">सन <br/>2024-2025<br/>या मागील<br/>वर्षाची प्रत्यक्ष<br/>रक्कम</th>
                                <th className="border border-black p-1 w-16">सन <br/>2023-2024<br/>या मागील<br/>वर्षाची प्रत्यक्ष<br/>रक्कम</th>
                                
                                <th className="border border-black p-1">खर्चाचे शिर्षक आणि मुंबई<br/>ग्रामपंचायत अधिनियम,<br/>1958, याचे कलम 45,<br/>पोट-कलम (1) अन्वये<br/>पंचायतीची कर्तव्ये पार<br/>पाडण्यावर योजिलेला खर्च</th>
                                
                                <th className="border border-black p-1 w-16">सन <br/>2025-2026 या<br/>वर्षाचा<br/>पंचायतीचा<br/>अंदाजलेला<br/>खर्च</th>
                                <th className="border border-black p-1 w-16">सन <br/>2025-2026<br/>या वर्षासाठी<br/>मंजुर केलेली<br/>अंदाजी रक्कम</th>
                                <th className="border border-black p-1 w-16">सन <br/>2024-2025<br/>या मागील<br/>वर्षाचा<br/>प्रत्यक्ष खर्च</th>
                                <th className="border border-black p-1 w-16">सन <br/>2023-2024<br/>या पुर्वीच्या<br/>वर्षाचा<br/>प्रत्यक्ष खर्च</th>
                                <th className="border border-black p-1 w-20">मुंबई ग्रामपंचायत<br/>अधिनियम, 1958 याच्या<br/>कलम 133 अन्वये<br/>स्थापन केलेल्या जिल्हा<br/>ग्रामविकास विधिस<br/>द्यावयाच्या अंशदानाची</th>
                            </tr>
                            
                            {/* Column Numbers */}
                            <tr className="bg-gray-100 text-[10px]">
                            <th className="border border-black p-1">(1)</th>
                            <th className="border border-black p-1">(2)</th>
                            <th className="border border-black p-1">(3)</th>
                            <th className="border border-black p-1">(4)</th>
                            <th className="border border-black p-1">(5)</th>
                            <th className="border border-black p-1">(6)</th>
                            <th className="border border-black p-1">(7)</th>
                            <th className="border border-black p-1">(8)</th>
                            <th className="border border-black p-1">(9)</th>
                            <th className="border border-black p-1">(10)</th>
                            <th className="border border-black p-1">(11)</th>
                            <th className="border border-black p-1">(12)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: maxRows }).map((_, idx) => {
                            const income = flatIncome[idx];
                            const expense = flatExpense[idx];

                            return (
                                <tr key={idx} className="hover:bg-gray-50">
                                    {/* (1) Initial Balance - Only on first row */}
                                    <td className="border border-black p-1 font-bold align-top">
                                        {idx === 0 ? '-24230' : ''}
                                    </td>

                                    {/* (2-6) Income Section */}
                                    {income ? (
                                        <>
                                            <td className={`border border-black p-1 text-left ${income.type === 'header' ? 'font-bold bg-gray-100' : ''} ${income.type === 'total' ? 'font-bold text-right bg-gray-50' : 'pl-4'}`}>
                                                {income.type === 'total' ? 'एकूण' : (income.content || income.name)}
                                            </td>
                                            <td className={`border border-black p-1 text-right ${income.type === 'total' ? 'font-bold bg-gray-50' : ''}`}>
                                                {income.currentEst !== undefined ? income.currentEst : ''}
                                            </td>
                                            <td className={`border border-black p-1 text-right ${income.type === 'total' ? 'font-bold bg-gray-50' : ''}`}>
                                                {income.currentSanctioned !== undefined ? income.currentSanctioned : ''}
                                            </td>
                                            <td className={`border border-black p-1 text-right ${income.type === 'total' ? 'font-bold bg-gray-50' : ''}`}>
                                                {income.lastYear !== undefined ? income.lastYear : ''}
                                            </td>
                                            <td className={`border border-black p-1 text-right ${income.type === 'total' ? 'font-bold bg-gray-50' : ''}`}>
                                                {income.prevYear !== undefined ? income.prevYear : ''}
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td className="border border-black p-1"></td>
                                            <td className="border border-black p-1"></td>
                                            <td className="border border-black p-1"></td>
                                            <td className="border border-black p-1"></td>
                                            <td className="border border-black p-1"></td>
                                        </>
                                    )}

                                    {/* (7-11) Expense Section */}
                                    {expense ? (
                                        <>
                                             <td className={`border border-black p-1 text-left ${expense.type === 'header' ? 'font-bold bg-gray-100' : ''} ${expense.type === 'total' ? 'font-bold text-right bg-gray-50' : 'pl-4'}`}>
                                                {expense.type === 'total' ? 'एकूण' : (expense.content || expense.name)}
                                            </td>
                                            <td className={`border border-black p-1 text-right ${expense.type === 'total' ? 'font-bold bg-gray-50' : ''}`}>
                                                {expense.currentEst !== undefined ? expense.currentEst : ''}
                                            </td>
                                            <td className={`border border-black p-1 text-right ${expense.type === 'total' ? 'font-bold bg-gray-50' : ''}`}>
                                                {expense.currentSanctioned !== undefined ? expense.currentSanctioned : ''}
                                            </td>
                                            <td className={`border border-black p-1 text-right ${expense.type === 'total' ? 'font-bold bg-gray-50' : ''}`}>
                                                {expense.lastYear !== undefined ? expense.lastYear : ''}
                                            </td>
                                            <td className={`border border-black p-1 text-right ${expense.type === 'total' ? 'font-bold bg-gray-50' : ''}`}>
                                                {expense.prevYear !== undefined ? expense.prevYear : ''}
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td className="border border-black p-1"></td>
                                            <td className="border border-black p-1"></td>
                                            <td className="border border-black p-1"></td>
                                            <td className="border border-black p-1"></td>
                                            <td className="border border-black p-1"></td>
                                        </>
                                    )}

                                    {/* (12) District Contribution - Only on first row */}
                                    <td className="border border-black p-1 font-bold align-top text-right">
                                        {idx === 0 ? '-24230' : ''}
                                    </td>
                                </tr>
                            );
                        })}

                        {/* Grand Total Row */}
                        <tr className="bg-gray-200 font-bold border-t-2 border-black">
                            <td className="border border-black p-1"></td>
                            <td className="border border-black p-1 text-right">एकूण</td>
                            <td className="border border-black p-1 text-right">{calculateTotal(incomeData, 'currentEst')}</td>
                            <td className="border border-black p-1 text-right">{calculateTotal(incomeData, 'currentSanctioned')}</td>
                            <td className="border border-black p-1 text-right">{calculateTotal(incomeData, 'lastYear')}</td>
                            <td className="border border-black p-1 text-right">{calculateTotal(incomeData, 'prevYear')}</td>
                            
                            <td className="border border-black p-1 text-right">एकूण</td>
                            <td className="border border-black p-1 text-right">{calculateTotal(expenseData, 'currentEst')}</td>
                            <td className="border border-black p-1 text-right">{calculateTotal(expenseData, 'currentSanctioned')}</td>
                            <td className="border border-black p-1 text-right">{calculateTotal(expenseData, 'lastYear')}</td>
                            <td className="border border-black p-1 text-right">{calculateTotal(expenseData, 'prevYear')}</td>
                            <td className="border border-black p-1"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <style>{`
                @media print {
                    @page {
                        size: A4 landscape;
                        margin: 0.5cm;
                    }
                    body {
                        -webkit-print-color-adjust: exact;
                        font-family: 'Times New Roman', serif;
                    }
                    .print-container {
                        width: 100%;
                        max-width: none;
                    }
                    /* Ensure borders print correctly */
                    th, td {
                        border: 1px solid black !important;
                    }
                    /* Hide scrollbars in print */
                    .overflow-x-auto {
                        overflow: visible !important;
                    }
                }
            `}</style>
        </div>
        </div>
    );
};

export default PanipuravthaNamuna1Print;
